/**
 * Relationships the artifact graph records between a conversation and an artifact.
 *
 * "Created / modified" is what the conversation produced or changed; the referenced set covers
 * artifacts it only pointed at — `attached` and `spawned_from` are reference-style links too.
 * `status_changed` belongs to neither: it's a webhook-emitted state event surfaced in the artifact
 * detail page's event history, not a "this conversation touched it" relationship.
 *
 * The query returns bare `Artifact` rows with no relationship field, so relationship can only be
 * applied as a server-side filter.
 */
export const CREATED_MODIFIED_RELATIONSHIPS = ['created', 'edited'];
export const REFERENCED_RELATIONSHIPS = ['referenced', 'attached', 'spawned_from'];

/**
 * Per-relationship cap on `conversationArtifacts`. Shared so every conversation-scoped reader sends
 * the same variables and Apollo dedupes them into one request. A conversation rarely produces many.
 */
export const CONVERSATION_ARTIFACTS_LIMIT = 50;
